/**
 * Template versions withdrawn because paper proved them wrong, each with the
 * version that corrects it. The two have the same zones, numbered alike, so a
 * card made on the old version opens, prints and folds on the new one with
 * its pictures where they were meant to be. The old documents stay published:
 * the correction is made here, as the app asks for them.
 *
 *   2026-10-18, the twisted purse: its first version (cd87933f) put the arm
 *   pictures on the side squares, which paper folds UNDER the arms, so the
 *   folded front came out blank. It also had the old two-step folding guide.
 *   Corrected by 159aca68 (arms on the corners, the eleven-step guide).
 *
 *   2026-10-25, the hexagonal packet: its first version (837f1a13) folded the ends
 *   before turning the band over, so the second flap had nothing to tuck into and
 *   the ends stayed loose (the owner's paper). Corrected by 628c902d: the 1910 order,
 *   the second flap woven under the hem the first fold brings up, two corner snips.
 *   Later the same day the owner asked for the FoldMyCard mark on the front, along the
 *   hem, and an invitation's code on the front too: cef837a2, the same zones again, so
 *   cards made on either earlier version take it. Then the mark larger, across most of the
 *   hem's strip (the owner): c0084bfc.
 */
const CORRECTED: Record<string, string> = {
  'twisted-purse/usletter/cd87933fcd9fe050': '159aca68ed597e16',
  'hexagonal-packet/usletter/837f1a13b9b340cf': 'c0084bfcd0758ee5',
  'hexagonal-packet/usletter/628c902d5251228e': 'c0084bfcd0758ee5',
  'hexagonal-packet/usletter/cef837a2d6d32d9f': 'c0084bfcd0758ee5',
};

/** The template version to fetch for a card made on `hash`: its correction, if it has one (no `sha256:`). */
export function versionToUse(id: string, paper: string, hash: string): string {
  const h = hash.replace(/^sha256:/, '');
  return CORRECTED[`${id}/${paper}/${h}`] ?? h;
}
